export const StaticTextFields = {
    header: {
        pageName: 'Header',
        list: [
            {
                label: "Header - advertisement",
                key: "header_item_advertisement"
            },
            {
                label: "Header - advertisement see more btn",
                key: "advertisement_see_more"
            },
            {
                label: "Header - services",
                key: "header_item_services"
            },
            {
                label: "Header - about",
                key: "header_item_about"
            },
            {
                label: "Header - work",
                key: "header_item_work"
            },
            {
                label: "Header - partner",
                key: "header_item_partner"
            },
            {
                label: "Header - contact",
                key: "header_item_contact"
            },
        ]
    },
    homepage: {
        pageName: 'Homepage',
        list: [
            {
                label: "Homepage - main title",
                key: "homepage_main_block_title"
            },
            {
                label: "Homepage - main description",
                key: "homepage_main_block_description"
            },
            {
                label: "Homepage - main btn title",
                key: "homepage_main_block_btn"
            },
            {
                label: "Homepage - partners block title1",
                key: "homepage_partners_block_title1"
            },
            {
                label: "Homepage - partners block count",
                key: "homepage_partners_block_count"
            },
            {
                label: "Homepage - partners block title2",
                key: "homepage_partners_block_title2"
            },
        ]


    },
    services:{
      pageName:"Services",
      list:[
          {
              label:"Service - blocks title",
              key:"service_blocks_title"
          },
          {
              label:"Service -  first block title",
              key:"service_first_block_title"
          },
          {
              label:"Service -  first block description",
              key:"service_first_block_description"
          },
          {
              label:"Service -  second block title",
              key:"service_second_block_title"
          },
          {
              label:"Service -  second block description",
              key:"service_second_block_description"
          },
          {
              label:"Service -  third block title",
              key:"service_third_block_title"
          },
          {
              label:"Service -  third block description",
              key:"service_third_block_description"
          },
      ]
    },
    work:{
      pageName:"How Work",
      list:[
          {
              label:"How Work -  step text",
              key:"work_step_text"
          },
          {
              label:"How Work -  more btn text",
              key:"work_more_btn_text"
          },
          {
              label:"How Work -  first block title",
              key:"work_first_block_title"
          },
          {
              label:"How Work -  first block description",
              key:"work_first_block_description"
          },
          {
              label:"How Work -  second block title",
              key:"work_second_block_title"
          },
          {
              label:"How Work -  second block description",
              key:"work_second_block_description"
          },
          {
              label:"How Work -  second block sub description",
              key:"work_second_block_sub_description"
          },
          {
              label:"How Work -  second block sub description second",
              key:"work_second_block_sub_description_second"
          },
          {
              label:"How Work -  third block title",
              key:"work_third_block_title"
          },
          {
              label:"How Work -  third block description",
              key:"work_third_block_description"
          },
      ]
    },
    about:{
      pageName:"About",
      list:[
          // {
          //     label:"About -  block supported count",
          //     key:"about_block_supported_count"
          // },
          {
              label:"About -  block Pepsi text",
              key:"about_block_supported_text"
          },
          // {
          //     label:"About -  block affiliates count",
          //     key:"about_block_affiliates_count"
          // },
          {
              label:"About -  block Philip Morris text",
              key:"about_block_affiliates_text"
          },
          // {
          //     label:"About -  block commissions paid",
          //     key:"about_block_commissions_paid"
          // },
          {
              label:"About -  block Dilijan text",
              key:"about_block_commissions_paid_text"
          },
          {
              label:"About -  block subTitle",
              key:"about_block_subTitle"
          },
          {
              label:"About -  block title",
              key:"about_block_title"
          },
          {
              label:"About -  block description",
              key:"about_block_description"
          },
          {
              label:"About -  block more btn text",
              key:"about_block_more_btn_text"
          },
      ]
    },
    contacts: {
        pageName: 'Contacts',
        list: [
            {
                label: "Contacts - block title",
                key: "contacts_block_title"
            },
            {
                label: "Contacts - block description",
                key: "contacts_block_description"
            },
            {
                label: "Contacts - block placeholder name",
                key: "contacts_block_placeholder_name"
            },
            {
                label: "Contacts - block label name",
                key: "contacts_block_label_name"
            },
            {
                label: "Contacts - block placeholder lastName",
                key: "contacts_block_placeholder_lastName"
            },
            {
                label: "Contacts - block label lastName",
                key: "contacts_block_label_lastName"
            },
            {
                label: "Contacts - block placeholder email",
                key: "contacts_block_placeholder_email"
            },
            {
                label: "Contacts - block label email",
                key: "contacts_block_label_email"
            },
            {
                label: "Contacts - block placeholder phoneNumber",
                key: "contacts_block_placeholder_phoneNumber"
            },
            {
                label: "Contacts - block label phoneNumber",
                key: "contacts_block_label_phoneNumber"
            },
            {
                label: "Contacts - block placeholder message",
                key: "contacts_block_placeholder_message"
            },
            {
                label: "Contacts - block label message",
                key: "contacts_block_label_message"
            },
            {
                label: "Contacts - block btn send",
                key: "contacts_block_btn_send"
            },
            {
                label: "Contacts - block service title",
                key: "contacts_block_service_title"
            },
            {
                label: "Contacts - block service notification",
                key: "contacts_block_service_notification"
            },
            {
                label: "Contacts - block service call centre",
                key: "contacts_block_service_call_centre"
            },
            {
                label: "Contacts - block service short number",
                key: "contacts_block_service_short_number"
            },
            {
                label: "Contacts - block service other",
                key: "contacts_block_service_other"
            },
        ]
    },
    footer: {
        pageName: 'Footer',
        list: [
            {
                label: "Footer - section copyright text",
                key: "footer_section_copyright_text"
            },
            {
                label: "Footer - section developed by text",
                key: "footer_section_developed_by_text"
            },
        ]
    },
}